import React from 'react'
import Headers from '../components/layout/Header'
import './home.css'
import { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Navigation } from "swiper/modules";
import { Pagination, Autoplay } from "swiper/modules";
import { tabsData } from '../components/layout/data';
import { data } from '../components/layout/data';
import { tabsandpillData } from '../components/layout/data';
import Footer from './Footer';
import image1 from '../assets/slider10.gif'
import image2 from '../assets/slider11.gif'
import image3 from '../assets/slider3.png'
import image4 from '../assets/what-is-suvidha.png'
import image6 from '../assets/need-a-hospital.png'
import image7 from '../assets/why-suvidha.png'
import { Link, useNavigate } from 'react-router-dom';
import ShowcaseSlider from './ShowcaseSlider';
import TestimonialSlider from './TestimonialSlider';
import Form from './Form';

function Home() {
   const [activeTab, setActiveTab] = useState(1);
  const activeData = tabsData.find(tab => tab.id === activeTab);
  const navigate = useNavigate();

   const [fabActiveTab, setFabActiveTab] = useState("moh");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Headers/>
        <Swiper
              modules={[Pagination, Autoplay]}
              pagination={{ clickable: true }}
              autoplay={{ delay: 4000 }}
              loop={true}
              className="hero-slider"
            >
      
              {/* SLIDE 1 */}
              <SwiperSlide>
                <div
                  className="slide"
                  style={{
                    backgroundImage:
                      `url(${image1})`,
                  }}
                >
                  <div className="overlay">
                    <h1>Healthy &<br></br> Happy Living </h1>
                    <p>Because growing older should feel like living fully.</p>
                    <Link to="/Contact"> <button className="cta-btn">connect with Us </button> </Link>
                  </div>
                </div>
              </SwiperSlide>
      
              {/* SLIDE 2 */}
              <SwiperSlide>
                <div
                  className="slide"
                  style={{
                    backgroundImage:
                      `url(${image2})`,

                  }}
                >
                  <div className="overlay">
                    <h1>Comforting Care, <br></br>Right at Home</h1>
                    <p>Compassionate nursing support for serious,<br></br> designed for comfort, dignity,and peace of mind.</p>
                    <Link to="/Contact"> <button className="cta-btn">Connect with us</button> </Link>
                  </div>
                </div>
              </SwiperSlide>
      
              {/* SLIDE 3 */}
           
      
            </Swiper>



       <section className="about-section">
      <div className="container about-grid">

        {/* LEFT IMAGE */}
        <div className="about-image">
          <img
            src={image4}
            alt="family care"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-content">
          <h2>What is suvidha?</h2>

          <h4>Your Care for Them. Our Presence Beside Them.<br></br>
          When distance keeps you away, Suvidha stays close.


</h4>

          <p>
           We support your parents with doctor-led healthcare, regular wellness monitoring, 
           rehabilitation, hospital assistance and everyday elder support — so they can continue
            living safely and independently at home, while you have peace of mind wherever you are.
          </p>

          <Link to="/learnmore"><button className="learn-btn">Learn More</button> </Link>

          
        </div>

      </div>
    </section>
       <section className="about-section">
      <div className="container about-grid">

          <div className="about-content">
          <h2>When They Need a Hospital,<br></br> We’re Right There.</h2>

          <h4>From Admission to Discharge, We Stay by Their Side
</h4>

          <p>
           When your parents need hospital care, distance shouldn’t leave them handling it alone.

          </p>

          <p>
           Suvidha coordinates the journey — from doctor consultations and hospital admission to tests, procedures, discharge and follow-up care — with a trusted care professional by their side.
          </p>
         
          {/* <button className="learn-btn">Explore Hospital Support</button> */}
          <Link to="/services"><button className="learn-btn">Explore Hospital Support</button> </Link>

        </div>

        {/* LEFT IMAGE */}
        <div className="about-image">
          <img
            src={image6}
            alt="family care"
          />
        </div>

        {/* RIGHT CONTENT */}
      

      </div>
    </section>
     <section className="about-section">
      <div className="container about-grid">

        {/* LEFT IMAGE */}
        <div className="about-image">
          <img
            src={image7}
            alt="family care"
          />
        </div>

        {/* RIGHT CONTENT */}
        <div className="about-content">
          <h2>Why Choose Suvidha?</h2>

          <h4>One Trusted Team. Every Care Need.
</h4>

          <p>
           Caring for an ageing parent shouldn’t mean coordinating different doctors, 
           nurses, therapists, hospitals and service providers on your own.
          </p>

          <p>
          Suvidha brings their care together through one coordinated support system. 
          Our team understands their needs, arranges the right assistance, follows up 
          after every intervention and stays involved as those needs change.
          </p>
   <p>
          One team that knows them.<br></br>
One system that follows through.<br></br>
Care that stays consistent.
          </p>

          {/* <button className="learn-btn">Why Families Trust Suvidha</button> */}
          <Link to="/blogs"><button className="learn-btn">Explore Our Blog</button> </Link>

        </div>

      </div>
    </section>
    
     <section className="services-section">

      <div className="container">

        {/* HEADER */}
        <div className="services-header">
          <h2>Solutions for Every Senior’s Needs</h2>
          {/* <span className="view-all">View all →</span> */}
        </div>

        {/* PILLS / TABS */}
      {/* TABS SLIDER */}
<div className="tabs-row">

 <Swiper
  modules={[Autoplay]}
  spaceBetween={20}
  slidesPerView={7}
  navigation={false}
  pagination={false}

  autoplay={{
    delay: 2000,              // 2 sec
    disableOnInteraction: false, // keep autoplay after click
    pauseOnMouseEnter: true, // pause on hover
  }}

  loop={true}   // important for smooth auto slide

  breakpoints={{
    320: { slidesPerView: 2 },
    768: { slidesPerView: 3 },
    1024: { slidesPerView: 4 },
  }}
>
  {tabsData.map(tab => (
    <SwiperSlide key={tab.id}>
      <div
        className={`tab-pill ${
          activeTab === tab.id ? "active" : ""
        }`}
        onClick={() => setActiveTab(tab.id)}
      >
        <div className="icon">{tab.icon}</div>
        <p>{tab.title}</p>
      </div>
    </SwiperSlide>
  ))}
</Swiper>


</div>


        {/* CONTENT */}
        <div className="tab-content">

          {/* TEXT */}
          <div className="content-left">
            <h3>{activeData.title}</h3>
            <p>{activeData.desc1}</p>
            <p>{activeData.desc2}</p>
            <button className="book-btn" onClick={() => navigate("/book-service")}>Book Services</button>
          </div>

          {/* IMAGE */}
          <div className="content-right">
            <img src={activeData.img} alt={activeData.title}  />
          </div>

        </div>
      </div>
    </section>



{/* <div className="benefits-section">
  <h2>Benefits for you</h2>

  <Swiper
    modules={[Navigation]}
    spaceBetween={60}              // bigger gap between cards
    slidesPerView={4}
    centeredSlides={true}           // center slides in view
    navigation
    loop={false}
    breakpoints={{
      320: { slidesPerView: 1, spaceBetween: 30 },
      768: { slidesPerView: 3, spaceBetween: 30 },
      1024: { slidesPerView: 4, spaceBetween: 30 }
    }}
  >
    {data.map((item, index) => (
      <SwiperSlide key={index}>
        <div className="benefit-card">
          <div className="img-box">
            <img src={item.img} alt={item.title} />
          </div>
          <h4>{item.title}</h4>
        </div>
      </SwiperSlide>
    ))}
  </Swiper>

  <button className="explore-btn">Explore Plans</button>
</div> */}



    <ShowcaseSlider />




     <section className="faq-section">

      <p className="mini-title">NEED MORE INFO</p>
      <h2>We got answers to your questions</h2>

      {/* ===== TABS / PILLS ===== */}

      <div className="faq-tabs">
        <button
          className={fabActiveTab === "moh" ? "active" : ""}
          onClick={() => {
            setFabActiveTab("moh");
            setOpenIndex(null);
          }}
        >
          suvidha care
        </button>

        <button
          className={fabActiveTab === "general" ? "active" : ""}
          onClick={() => {
            setFabActiveTab("general");
            setOpenIndex(null);
          }}
        >
          General
        </button>

        <button
          className={fabActiveTab === "plans" ? "active" : ""}
          onClick={() => {
            setFabActiveTab("plans");
            setOpenIndex(null);
          }}
        >
          Plans
        </button>
      </div>


      {/* ===== ACCORDION ===== */}

      <div className="faq-grid">
        {tabsandpillData[fabActiveTab].map((item, index) => (
          <div
            key={index}
            className={`faq-card ${
              openIndex === index ? "open" : ""
            }`}
          >
            <div
              className="faq-question"
              onClick={() => toggleAccordion(index)}
            >
              {item.question}
              <span>{openIndex === index ? "×" : "+"}</span>
            </div>

            {openIndex === index && (
              <div className="faq-answer">
                {item.answer}
              </div>
            )}
          </div>
        ))}
      </div>

    </section>

    <TestimonialSlider/>



    <Form/>

    <Footer/>


    </>
  )
}

export default Home